<!--
 * @Author: DY
 * @Date: 2025-02-18 17:11:52
 * @LastEditTime: 2025-03-06 14:20:54
 * @Description: 发货明细【销售管理-客户验收审批】
 * @FilePath: \ShiMo_Mobile\src\views\sales\customerAcceptanceProcessing\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="customerAcceptanceProcessingForm commonFormStyles">
            <HeaderNav
                header-title="客户质量验收处理表"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <ul class="formList">
                <van-field
                    disabled
                    label="质量验收单号"
                    placeholder="自动生成"
                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                    v-model="formData.CheckAcceptNumber"
                ></van-field>
                <van-field
                    readonly
                    label="发货通知单号"
                    placeholder="选择发货通知单"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_34@2x.png')"
                    v-model="formData.DeliveryNoticeNumber"
                    @click="selectDeliveryNotice"
                ></van-field>
                <van-field
                    disabled
                    label="客户名称"
                    placeholder="选择发货通知单"
                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                    v-model="formData.ClientName"
                ></van-field>
                <van-field
                    disabled
                    label="合同编号"
                    placeholder="选择发货通知单"
                    :left-icon="require('@/assets/images/icons/icon_1@2x.png')"
                    v-model="formData.ContractNo"
                ></van-field>
                <van-field
                    readonly
                    label="物料代码"
                    placeholder="选择物料"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                    v-model="formData.MaterialCodes"
                    @click="selectMaterial"
                ></van-field>
                <van-field
                    disabled
                    label="短描述"
                    placeholder="选择物料"
                    :left-icon="require('@/assets/images/icons/icon_28@2x.png')"
                    v-model="formData.MaterialShortNames"
                ></van-field>
                <van-field
                    disabled
                    label="发货数量（吨）"
                    placeholder="选择物料"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.DeliveryWeight"
                ></van-field>
                <van-field
                    disabled
                    label="签收数量（吨）"
                    placeholder="选择物料"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.SignWeight"
                ></van-field>
                <van-field
                    disabled
                    label="业务员"
                    placeholder="选择发货通知单"
                    :left-icon="require('@/assets/images/icons/icon_8@2x.png')"
                    v-model="formData.SalesmanName"
                ></van-field>
                <van-field
                    disabled
                    label="联系电话"
                    placeholder="选择发货通知单"
                    :left-icon="require('@/assets/images/icons/icon_9@2x.png')"
                    v-model="formData.SalesmanPhone"
                ></van-field>
                <van-field
                    type="textarea"
                    label="客户质量验收意见"
                    placeholder="请填写意见"
                    :rows="3"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_10@2x.png')"
                    v-model="formData.CheckAcceptOpinion"
                ></van-field>
                <van-field
                    readonly
                    label="争议解决方式"
                    placeholder="选择争议解决方式"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_2@2x.png')"
                    v-model="disputeSolutionMethod"
                    @click="showActionSheet = true"
                ></van-field>
                <van-field
                    label="扣吨（吨）"
                    placeholder="请输入扣吨"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_6@2x.png')"
                    v-model="formData.DeductWeight"
                ></van-field>
                <van-field
                    label="扣金额（元）"
                    placeholder="请输入扣金额"
                    :disabled="isDisabled"
                    :left-icon="require('@/assets/images/icons/icon_26@2x.png')"
                    v-model="formData.DeductMoney"
                ></van-field>
            </ul>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="handleSubmit">
                        提交
                    </button>
                    <button class="confirm" @click="handleSave(null)">
                        保存
                    </button>
                </template>
                <button class="confirm" @click="closeAllocationForm">
                    关闭
                </button>
            </footer>
            <van-action-sheet
                v-model="showActionSheet"
                cancel-text="取消"
                description="选择争议解决方式"
                close-on-click-action
                :actions="actionSheetData"
                @select="selectConfirm"
            ></van-action-sheet>
            <van-dialog
                v-model="confirmedByShow"
                title="提交确认"
                show-cancel-button
                @cancel="cancelSubmission"
                @confirm="confirmSubmission"
                class="submitPopUp"
            >
                <div class="submitPopUpContent">
                    <div class="icon">
                        <img src="@/assets/images/contractApproval/icon.png" alt="">
                    </div>
                    <div class="info linkInfo">
                        <h4>
                            下一环节：
                            <span>{{ submitObj.link }}</span>
                        </h4>
                        <h4>
                            审批人：
                            <span>{{ submitObj.obj }}</span>
                        </h4>
                        <p>是否确认提交？</p>
                    </div>
                </div>
            </van-dialog>
        </div>
    </v-touch>
</template>

<script>
import { HeaderNav } from '@/components/';
import mixin_formSubmissionProcess from '@/components/processHandling/mixin/mixin_formSubmissionProcess';

export default {
    // 库位表单
    name: 'customer-acceptance-processing-form',
    components: {
        HeaderNav,
    },
    beforeRouteLeave(to, from, next) {
        if (to.path !== '/selectListView') {
            this.$store.commit('noKeepAlive', 'customer-acceptance-processing-form');
        }
        next();
    },
    mixins: [mixin_formSubmissionProcess],
    props: {},
    data() {
        return {
            isDisabled: false,
            openType: '',
            formData: {
                Id: '',
                BusinessInstanceId: '',
                BusinessCode: '',
                CheckAcceptNumber: '',
                DeliveryNoticeId: '',
                DeliveryNoticeNumber: '',
                ContractNo: '',
                ContractNumber: '',
                ClientId: '',
                ClientName: '',
                MaterialCodes: '',
                MaterialShortNames: '',
                DeliveryWeight: 0,
                SignWeight: 0,
                SalesmanId: '',
                SalesmanName: '',
                SalesmanPhone: '',
                DisputeSolution: '',
                DeductWeight: 0,
                DeductMoney: 0,
                ApproveStatus: 0,
                CheckAcceptOpinion: '',
                RegisterDate: '',
                AutoIndex: 0,
                YearIndex: '',
            },
            showActionSheet: false,
            actionSheetData: [{
                name: '不处罚',
                value: '0',
            },
            // {
            //     name: '扣量',
            //     value: '1',
            // }, 
            {
                name: '扣款',
                value: '2',
            }, {
                name: '退货',
                value: '3',
            }],
            disputeSolutionMethod: '',
            businessCode: 'XS-KHYSH-SP',
            isSaveOperation: false,
            backPathName: 'customerAcceptanceProcessing',
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.deliveryNotice) {
            this.formData.DeliveryNoticeId = this.$route.params.deliveryNotice[0].id;
            this.formData.DeliveryNoticeNumber = this.$route.params.deliveryNotice[0].delivery_notice_number;
            this.formData.ContractNo = this.$route.params.deliveryNotice[0].contract_no;
            this.formData.ClientId = this.$route.params.deliveryNotice[0].client_id;
            this.formData.ClientName = this.$route.params.deliveryNotice[0].client_name;
            this.formData.SalesmanName = this.$route.params.deliveryNotice[0].salesman_name;
            this.formData.SalesmanPhone = this.$route.params.deliveryNotice[0].salesman_phone;
        }
        if (this.$route.params.material) {
            this.formData.MaterialCodes = this.$route.params.material[0].material_code;
            this.formData.MaterialShortNames = this.$route.params.material[0].material_short_name;
            this.formData.DeliveryWeight = this.$route.params.material[0].delivery_weight;
            this.formData.SignWeight = this.$route.params.material[0].sign_weight;
        }
    },
    async created() {
        this.openType = this.$route.params.type;
        if (this.openType === 'add') {
            this.getBusinessInstance();
        } else {
            this.formData = await this.getformRequrst(this.$route.params.id);
            this.loadDisputeSolutionMethod();
        }
        if (this.openType === 'view') {
            this.isDisabled = true;
        }
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'customerAcceptanceProcessing',
                params: {
                    isRefresh: this.isSaveOperation,
                },
            });
            this.$router.go(-1);
        },
        selectDeliveryNotice() {
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择发货通知单',
                    sourcePath: 'customerAcceptanceProcessingForm',
                    listCode: 'client_select_delivery_notice',
                    callbackDataKey: 'deliveryNotice',
                    relationKey: 'id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '发货通知单号',
                        code: 'delivery_notice_number',
                        isTitle: true,
                    }, {
                        name: '客户名称',
                        code: 'client_name',
                        icon: 'icon_1@2x',
                    }, {
                        name: '合同编号',
                        code: 'contract_no',
                        icon: 'icon_1@2x',
                    }, {
                        name: '业务员',
                        code: 'salesman_name',
                        icon: 'icon_8@2x',
                    }, {
                        name: '联系电话',
                        code: 'salesman_phone',
                        icon: 'icon_9@2x',
                    }],
                },
            });
        },
        selectMaterial() {
            if ((this.formData.DeliveryNoticeId || '') === '') {
                this.$toast('请先选择发货通知单！');
                return;
            }
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    pageTitle: '选择物料',
                    sourcePath: 'customerAcceptanceProcessingForm',
                    listCode: 'client_select_delivery_material',
                    callbackDataKey: 'material',
                    requestUrl: `/basicplatform/tabledata?delivery_notice_id=${this.formData.DeliveryNoticeId}`,
                    relationKey: 'material_code',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '物料代码',
                        code: 'material_code',
                        isTitle: true,
                    }, {
                        name: '长描述',
                        code: 'material_name',
                        icon: 'icon_10@2x',
                    }, {
                        name: '短描述',
                        code: 'material_short_name',
                        icon: 'icon_28@2x',
                    }, {
                        name: '发货数量（吨）',
                        code: 'delivery_weight',
                        icon: 'icon_6@2x',
                    }, {
                        name: '签收数量（吨）',
                        code: 'sign_weight',
                        icon: 'icon_6@2x',
                    }],
                },
            });
        },
        selectConfirm(data) {
            this.disputeSolutionMethod = data.name;
            this.formData.DisputeSolution = data.value;
        },
        loadDisputeSolutionMethod() {
            const res = this.actionSheetData.filter(item => item.value === this.formData.DisputeSolution);
            if ((res || []).length > 0) {
                this.disputeSolutionMethod = res[0].name;
            }
        },
        async handleSave(callBackFn) {
            const res = await this.saveFormRequrst(this.formData);
            if (res) {
                this.formData = res;
                this.formKeyValue = res.Id;
                this.loadDisputeSolutionMethod();
                if (this.openType === 'add') {
                    this.startBusinessInstance(callBackFn, this.formData);
                    this.openType = 'edit';
                    this.$toast('保存成功！');
                } else {
                    this.$toast('修改成功！');
                    this.getCurrentProcess(callBackFn);
                }
                this.isSaveOperation = true;
            }
        },
        closeAllocationForm() {
            this.$router.isBack = 1;
            this.$router.replace({
                name: 'customerAcceptanceProcessing',
            });
            this.$router.go(-1);
        },
        getformRequrst(id) {
            return this.$axios.$post(`/interfaceApi/sale/client_check/info/${id}`);
        },
        saveFormRequrst(requestData) {
            return this.$axios.$post('/interfaceApi/sale/client_check/save', requestData);
        },
    },
};
</script>
<style lang="stylus">
.customerAcceptanceProcessingForm
    background: #f0f0f0;
    .formList
        padding 10rpx
        height calc(100% - 124rpx)
        overflow-y auto
        .list_item
            margin-bottom 10rpx
            background #fff
            box-shadow: 0px 0px 3px 0px #b5b5b5;
            border-radius: 4rpx;
            position relative
            overflow hidden
            &:last-child
                margin-bottom 0
            .title
                width 100%
                height 42rpx
                background #F8F8F8
                margin-bottom 0 !important
                display flex
                align-items center
                padding 0 10rpx
                font-size 16rpx
                position relative
                display: flex;
                justify-content: space-between;
                >span
                    color: #e93743
                    display: flex;
                    justify-content: center;
                    align-items: center;
</style>
